"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import FlyoutControlled from "./FlyoutControlled.js";
const FlyoutUncontrolled = (props) => {
    const { defaultActive, onClose, onOpen } = props;
    const [active, setActive] = React.useState(defaultActive || false);
    const handleClose = (args) => {
        setActive(false);
        onClose?.(args);
    };
    const handleOpen = () => {
        setActive(true);
        onOpen?.();
    };
    return (_jsx(FlyoutControlled, { ...props, defaultActive: undefined, active: active, onClose: handleClose, onOpen: handleOpen }));
};
FlyoutUncontrolled.displayName = "FlyoutUncontrolled";
export default FlyoutUncontrolled;
